<template>
  <div class="relative z-10 hidden xl:block">
    <div class="relative w-[600px] h-full">
      <div
        class="bg-gradient-to-br from-h-primary-500 to-h-primary-400 rounded-full w-[95%] h-0 pb-[95%] mx-auto relative shadow-2xl blob"
      >
        <div class="absolute inset-0 flex items-center justify-center">
          <div
            class="bg-white w-[85%] h-[75%] rounded-xl shadow-2xl flex flex-col transform rotate-1 hover:rotate-0 transition-transform duration-500"
          >
            <div
              class="h-8 bg-gray-100 rounded-t-xl flex items-center px-3 gap-1.5"
            >
              <div class="w-3 h-3 rounded-full bg-h-secondary-500"></div>
              <div class="w-3 h-3 rounded-full bg-h-neutral-500"></div>
              <div class="w-3 h-3 rounded-full bg-h-primary-500"></div>
            </div>
            <div
              class="flex-grow bg-gray-50 flex items-center justify-center rounded-b-xl"
            >
              <button
                class="group w-32 h-32 bg-gray-200 rounded-full flex items-center justify-center transition-all duration-300 hover:scale-105"
              >
                <div
                  class="w-24 h-24 bg-h-primary-500 rounded-full flex items-center justify-center group-hover:bg-h-primary-500 transition-colors"
                >
                  <v-icon
                    name="md-playarrow"
                    :scale="2.5"
                    class="text-h-secondary-500"
                  />
                </div>
              </button>
            </div>
          </div>
        </div>
        <div
          class="absolute -bottom-6 -right-6 w-32 h-32 bg-gray-200 opacity-20 rounded-full"
        ></div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "HeroComponent",
});
</script>
